/* One-time entrances and useful feedback. No purchases, analytics requests or app overrides. */
(()=>{
 'use strict';
 if(window.mbmConversionV12)return;window.mbmConversionV12=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const observed=new WeakSet(),animated=new WeakSet(),bound=new WeakSet(),purchaseCards=new WeakSet(),running=new Set();
 const animations=(element,keyframes,options)=>{
  if(reduced.matches||!element?.animate)return;
  const animation=element.animate(keyframes,options);running.add(animation);
  animation.finished.then(()=>running.delete(animation),()=>running.delete(animation));
 };
 reduced.addEventListener('change',()=>{if(reduced.matches){running.forEach(a=>a.cancel());running.clear();}});
 const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   observer.unobserve(entry.target);if(animated.has(entry.target))return;animated.add(entry.target);
   animations(entry.target,[{opacity:.45,translate:'0 22px'},{opacity:1,translate:'0 0'}],{duration:560,delay:Number(entry.target.dataset.mbmV12Delay||0),easing:'cubic-bezier(.2,.65,.3,1)'});
  });
 },{threshold:.12,rootMargin:'0px 0px -25px 0px'}):null;
 function initialize(scope=document){
  scope.querySelectorAll('.product__info-container [class*="sunzi__customize-now-wrapper"]>[class*="sunzi__button-"],[class*="sunzi__customize-now-wrapper"]>[class*="sunzi__button-"]').forEach(trigger=>{
   if(bound.has(trigger)||trigger.tagName==='BUTTON')return;bound.add(trigger);
   trigger.setAttribute('role','button');trigger.setAttribute('tabindex','0');
   trigger.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();trigger.click();}});
  });
  scope.querySelectorAll('.product__info-container').forEach(card=>{
   if(purchaseCards.has(card)||!('MutationObserver'in window))return;purchaseCards.add(card);let scheduled=false;
   const updates=new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;if(card.isConnected)initialize(card);else updates.disconnect();});});
   updates.observe(card,{childList:true,subtree:true});
   document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(card))updates.disconnect();});
  });
  scope.querySelectorAll('.mbm-product,.mbm-result,.mbm-category,.mbm-doll-features article,.mbm-doll-occasions article,.mbm-v12-choice').forEach((el,index)=>{
   if(observed.has(el))return;observed.add(el);el.dataset.mbmV12Delay=String((index%4)*55);observer?.observe(el);
  });
  scope.querySelectorAll('.mbm-studio-hero__visual').forEach(hero=>{
   if(bound.has(hero))return;bound.add(hero);
   hero.querySelectorAll('[data-mbm-depth-card]').forEach((card,index)=>animations(card,[{opacity:.4,translate:index?'15px 18px':'-10px 25px'},{opacity:1,translate:'0 0'}],{duration:750,delay:120+index*120,easing:'cubic-bezier(.2,.65,.3,1)'}));
  });
  scope.querySelectorAll('variant-selects').forEach(picker=>{
   if(bound.has(picker))return;bound.add(picker);
   picker.addEventListener('change',()=>{
    const card=picker.closest('.product__info-container');const summary=card?.querySelector('.mbm-doll-summary');
    animations(summary,[{boxShadow:'0 0 0 0px #b64c3d00'},{boxShadow:'0 0 0 4px #b64c3d26'},{boxShadow:'0 0 0 0px #b64c3d00'}],{duration:650,easing:'ease-out'});
   });
  });
  scope.querySelectorAll('.mbm-faq details,.mbm-v8-panel details').forEach(detail=>{
   if(bound.has(detail))return;bound.add(detail);
   detail.addEventListener('toggle',()=>{if(detail.open){const content=[...detail.children].find(e=>e.tagName!=='SUMMARY');animations(content,[{opacity:.5,translate:'0 -5px'},{opacity:1,translate:'0 0'}],{duration:230,easing:'ease-out'});}});
  });
  scope.querySelectorAll('.mbm-mobile-menu__panel,.mbm-desktop-nav').forEach(menu=>{
   const seen=new Set();
   menu.querySelectorAll('a').forEach(link=>{
    const key=link.getAttribute('href')+'|'+link.textContent.trim();
    if(seen.has(key)){link.hidden=true;return;}seen.add(key);
    if(decodeURI(link.getAttribute('href')||'').includes('/collections/בובות'))link.classList.add('mbm-v12-menu-feature');
   });
  });
 }
 initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
 document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-mbm-v12-delay]').forEach(el=>observer?.unobserve(el));});
})();
